// In-memory token store — token is never written to localStorage.
// On page refresh, AuthContext restores the session from the httpOnly cookie via /auth/me.

let _token = null;

export const setToken = (t) => { _token = t || null; };
export const clearToken = () => { _token = null; };
export const getToken = () => _token;
